import { Profile } from '@/profile/profile'
import { request } from '@/api/internalApi.ts'

export const getProfileData = async (id: string) => request<Profile>('get', `assistant/threads/${id}/profile`)
